// --------------------- Import Globais ---------------------
import { useEffect, useState } from "react";
// --------------------- Import Antd-Design ---------------------
import { Card, Modal, Select } from "antd";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  DollarCircleOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
// --------------------- Import Hooks ---------------------
import { useAtualizarIndicacoesParceiros } from "../hooks/useAtualizarIndicacoesParceiros";
// --------------------- Import Styles ---------------------
import { Title } from "../../ViewGerenciarPostagens/styles";
// --------------------- Import Uteis ---------------------
import { useMessage } from "../../../uteis/mensagens/useMessage";
import { ContainerModal, ItemTextModal, ItemWrapper } from "../styles";
import { IndicacaoParceiro } from "../../../interfaces/IndicacaoParceiro";

const statusOptions = [
  {
    label: (
      <>
        <CheckCircleOutlined style={{ color: "green", marginRight: 8 }} />
        Verificar
      </>
    ),
    value: "VERIFICAR",
  },
  {
    label: (
      <>
        <CloseCircleOutlined style={{ color: "red", marginRight: 8 }} />
        Desistiu
      </>
    ),
    value: "DESISTIU",
  },
  {
    label: (
      <>
        <ExclamationCircleOutlined
          style={{ color: "#faad14", marginRight: 8 }}
        />
        Pendente Pagamento
      </>
    ),
    value: "PENDENTE_PAGAMENTO",
  },
  {
    label: (
      <>
        <DollarCircleOutlined style={{ color: "green", marginRight: 8 }} />
        Pago
      </>
    ),
    value: "PAGO",
  },
];

interface ModalStatusProps {
  isModalOpen: boolean;
  handleFechar: () => void;
  indicacaoId: number; // depende do seu sistema, ajuste se necessário
  indicacaoStatus: string;
  buscar: () => void;
}

export default function ModalStatus({
  isModalOpen,
  handleFechar,
  indicacaoId,
  indicacaoStatus,
  buscar,
}: ModalStatusProps) {
  // Seta o dado que irá ser atualizado
  const [indicacaoData, setIndicacaoData] = useState<
    Partial<IndicacaoParceiro>
  >({});

  // Chamada da função para atualizar
  const {
    atualizar,
    isLoading: isLoadingAtualizar,
    error,
    success,
    resetSuccess,
    resetError,
  } = useAtualizarIndicacoesParceiros();

  // Exibe a Mensagem de  Erro
  const { showSuccess, showError, contextHolder } = useMessage();

  // Estado para controlar se o erro já foi exibido
  const [errorDisplayed, setErrorDisplayed] = useState(false);

  // Estado para controlar se o sucesso já foi exibido
  const [successDisplayed, setSuccessDisplayed] = useState(false);

  const handleStatusChange = (value: string) => {
    setIndicacaoData({
      id: indicacaoId,
      status: value,
    });
  };

  useEffect(() => {
    if (isModalOpen) {
      setIndicacaoData({ status: indicacaoStatus });
    }
  }, [isModalOpen, indicacaoStatus]);

  useEffect(() => {
    if (isModalOpen && success && !successDisplayed) {
      // Mensagem de sucesso
      const msgSuccess = "Status da Indicação alterado com sucesso!";
      showSuccess(msgSuccess);
      setSuccessDisplayed(true);

      // Limpa sucesso após 3 segundos
      setTimeout(() => {
        resetSuccess();
        handleFechar();
        buscar();
      }, 2000);
    }

    if (isModalOpen && error && !errorDisplayed) {
      // Mensagem de erro
      let msgError =
        "Não foi possível atualizar a indicação, por favor tente novamente!";
      showError(msgError);
      setErrorDisplayed(true);

      // Limpa erro após 3 segundos
      setTimeout(() => {
        setErrorDisplayed(false);
        resetError();
      }, 3000);
    }

    // Reset quando o modal fecha
    if (!isModalOpen) {
      setSuccessDisplayed(false);
      setErrorDisplayed(false);
    }
  }, [
    isModalOpen,
    success,
    error,
    showSuccess,
    resetSuccess,
    showError,
    successDisplayed,
    errorDisplayed,
    resetError,
  ]);

  return (
    <>
      <Modal
        open={isModalOpen}
        onCancel={handleFechar}
        cancelText="Cancelar"
        okText="Atualizar"
        onOk={() => atualizar(indicacaoData)}
        confirmLoading={isLoadingAtualizar}
        okButtonProps={{
          style: {
            backgroundColor: "#003644",
            borderColor: "#003644",
            color: "white",
          }, // Botão "Ativar" com fundo verde
        }}
        cancelButtonProps={{
          style: {
            backgroundColor: "#f44336",
            borderColor: "#f44336",
            color: "white",
          }, // Botão "Cancelar" com fundo vermelho
        }}
      >
        <>{contextHolder}</>
        <Card
          title={<Title>Alterar Status</Title>}
          style={{
            width: "100%",
            marginTop: "20px",
            borderRadius: "10px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
          }}
        >
          <ContainerModal>
            <ItemWrapper>
              <ItemTextModal>Status Atual</ItemTextModal>
              <Select
                style={{ width: "100%" }}
                value={indicacaoData.status}
                onChange={handleStatusChange}
                options={statusOptions}
              />
            </ItemWrapper>
          </ContainerModal>
        </Card>
      </Modal>
    </>
  );
}
